import sendaiLogo from "./assets/sendai.png";
import taprushLogo from "./assets/taprush-logo.png";
import bitsLogo from "./assets/bits-logo.png";
import suziClip from "./assets/suzi-clip.mp4";
import suziPoster from "./assets/suzi-poster.jpg";
import taprushClip from "./assets/taprush-clip.mp4";
import taprushPoster from "./assets/taprush-poster.jpg";
import perpsClip from "./assets/perps-clip.mp4";
import perpsPoster from "./assets/perps-poster.jpg";
import aggregatorClip from "./assets/aggregator-clip.mp4";
import aggregatorPoster from "./assets/aggregator-poster.jpg";
import aiBuilderClip from "./assets/ai-builder-clip.mp4";
import aiBuilderPoster from "./assets/ai-builder-poster.jpg";
import portfolioBuilderClip from "./assets/portfolio-builder-clip.mp4";
import portfolioBuilderPoster from "./assets/portfolio-builder-poster.jpg";
import bookDune from "./assets/book-dune.jpg";
import book1984 from "./assets/book-1984.jpg";
import bookThreeBody from "./assets/book-three-body.jpg";
import bookMartian from "./assets/book-martian.jpg";
import bookHailMary from "./assets/book-hail-mary.jpg";
import bookNeuromancer from "./assets/book-neuromancer.jpg";
import type { Art } from "./components/ui/RetroArt";

export const EMAIL = "sanskritisinghh2005@gmail.com";
export const RESUME = "/resume.pdf";
export const GITHUB_USER = "sanskritisingh245";

export const SOCIALS = [
  { label: "GitHub", href: "https://github.com/sanskritisingh245", icon: "github" },
  { label: "LinkedIn", href: "https://www.linkedin.com/in/sanskriti-singh-5866553ab/", icon: "linkedin" },
  { label: "X", href: "https://x.com/24_sansss", icon: "x" },
] as const;

export interface Experience {
  company: string;
  logo: string;
  logoSrc?: string;
  role: string;
  period: string;
  location: string;
  points: string[];
  stack?: string[];
}

export const EXPERIENCE: Experience[] = [
  {
    company: "TapRush",
    logo: "TR",
    logoSrc: taprushLogo,
    role: "Founder & Engineer",
    period: "Apr 2026 - Present",
    location: "India - Remote",
    points: [
      "Built and published TapRush, a 1v1 quick-draw betting game, on the Solana dApp Store.",
      "Built the React Native / Expo app with wallet integration, matchmaking, and haptic-driven gameplay.",
      "Built the Node.js / PostgreSQL backend and the on-chain Solana program behind it.",
      "Handled production end to end, deploying Dockerized services on a self-managed VPS.",
    ],
  },
  {
    company: "sendAI",
    logo: "SE",
    logoSrc: sendaiLogo,
    role: "Mobile Developer Intern",
    period: "Mar 2026 - Sep 2026",
    location: "Remote",
    points: [
      "Built and shipped features for production mobile apps used by real users.",
      "Handled production releases end to end, including builds, app store submissions, and post-release updates.",
      "Integrated APIs and authentication, and worked with designers and backend devs to deliver polished end-to-end features.",
    ],
  },
];

export const EDUCATION = {
  school: "BITS Pilani",
  logo: "BP",
  logoSrc: bitsLogo,
  degree: "B.Sc. Computer Science",
  period: "2025 - 2029",
  location: "Pilani, Rajasthan",
};

export interface Project {
  name: string;
  /** retro artwork revealed behind the screenshot on hover */
  art: Art;
  description: string;
  /** short muted loop, plus a still shown until it plays */
  video: string;
  poster: string;
  portrait?: boolean;
  status: string;
  github?: string;
  live?: string;
}

export const PROJECTS: Project[] = [
  {
    name: "Suzi",
    description:
      "A self-custodial, multi-chain crypto wallet with a chat interface to research, swap, and trade tokens with live market data, all from one conversation.",
    video: suziClip,
    poster: suziPoster,
    portrait: true,
    art: { kind: "swirl", base: "#f7e4e8", colors: ["#e2557f", "#f4b6c8", "#9c2f5a"], twist: 1.2, sun: "#f29bb8" },
    status: "App Store",
    live: "https://apps.apple.com/in/app/suzi/id6760543806",
  },
  {
    name: "TapRush",
    art: { kind: "swirl", base: "#f6e3c8", colors: ["#e8896a", "#f2b49b", "#a9d6c3"], twist: 1, sun: "#f0b53f" },
    description:
      "A 1v1 quick-draw betting game on Solana. Wager SOL, wait for the haptic buzz, and the first tap wins the pot.",
    video: taprushClip,
    poster: taprushPoster,
    portrait: true,
    status: "dApp Store",
    github: "https://github.com/sanskritisingh245/TapRush",
  },
  {
    name: "Perps",
    art: { kind: "burst", base: "#f3e2b3", colors: ["#3d8ea0", "#c8473a", "#e8b04b"] },
    description:
      "A perpetual futures exchange built as event-driven microservices, with a matching engine, liquidations, and live WebSocket feeds over Redis Streams.",
    video: perpsClip,
    poster: perpsPoster,
    status: "Live",
    github: "https://github.com/sanskritisingh245/perpsV2",
    live: "https://perps.sanskriti.xyz",
  },
  {
    name: "Aggregator",
    art: { kind: "waves", base: "#f7e9d2", colors: ["#e1874a", "#e9b04b", "#f3b8b3"] },
    description:
      "Real-time Solana token aggregator merging DexScreener, Jupiter, and CoinGecko, cached in Redis and streamed over WebSockets.",
    video: aggregatorClip,
    poster: aggregatorPoster,
    status: "Live",
    github: "https://github.com/sanskritisingh245/Aggregator",
    live: "https://aggregator-fe.vercel.app/",
  },
  {
    name: "AI Component Builder",
    art: { kind: "swirl", base: "#f1e6c5", colors: ["#6fb4a7", "#d2a24c"], twist: 1.5 },
    description:
      "Turn natural-language prompts into styled React components, with a live isolated preview and a saved gallery.",
    video: aiBuilderClip,
    poster: aiBuilderPoster,
    status: "Live",
    github: "https://github.com/sanskritisingh245/ai-component-builder",
    live: "https://ai-component-builder.vercel.app/",
  },
  {
    name: "Portfolio Builder",
    art: { kind: "swirl", base: "#efe3c8", colors: ["#8e2f3a", "#2f3b60", "#3c8a9b", "#79abc9", "#a9b545", "#d86a2c"], twist: 0.7 },
    description:
      "Describe yourself in plain English and get a finished portfolio, generated with Gemini from a curated template catalog.",
    video: portfolioBuilderClip,
    poster: portfolioBuilderPoster,
    status: "Live",
    github: "https://github.com/sanskritisingh245/portfolio-builder",
    live: "https://portfolio-builder-ten-delta.vercel.app/",
  },
];

/** [name, Simple Icons slug] — slug omitted where Simple Icons has no mark */
export const SKILLS: [string, string?][] = [
  ["TypeScript", "typescript"],
  ["JavaScript", "javascript"],
  ["Go", "go"],
  ["Swift", "swift"],
  ["SQL"],
  ["Node.js", "nodedotjs"],
  ["Bun", "bun"],
  ["Express", "express"],
  ["FastAPI", "fastapi"],
  ["Socket.io", "socketdotio"],
  ["Zod", "zod"],
  ["React", "react"],
  ["Next.js", "nextdotjs"],
  ["React Native", "react"],
  ["Expo", "expo"],
  ["Tailwind", "tailwindcss"],
  ["Vite", "vite"],
  ["PostgreSQL", "postgresql"],
  ["Prisma", "prisma"],
  ["Redis", "redis"],
  ["MongoDB", "mongodb"],
  ["Docker", "docker"],
  ["Kubernetes", "kubernetes"],
  ["AWS"],
  ["Solana", "solana"],
];

export const BOOKS = [
  { title: "Dune", author: "Frank Herbert", year: "1965", cover: bookDune },
  { title: "The Three-Body Problem", author: "Cixin Liu", year: "2008", cover: bookThreeBody },
  { title: "The Martian", author: "Andy Weir", year: "2011", cover: bookMartian },
  { title: "1984", author: "George Orwell", year: "1949", cover: book1984 },
  { title: "Project Hail Mary", author: "Andy Weir", year: "2021", cover: bookHailMary },
  { title: "Neuromancer", author: "William Gibson", year: "1984", cover: bookNeuromancer },
];

export const QUOTE = {
  text: "Make it work, make it right, make it fast.",
  author: "Kent Beck",
};
